package com.fireavert.events.shared.data_models.models

data class UnitEventTotals(
    val alarmEvents: Int = 0,
    val shutoffEvents: Int = 0,
    val leakEvents: Int = 0,
    val flowEvents: Int = 0,
    val tamperEvents: Int = 0
)
